/*
i18n.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import English from './assets/i18n/en.json';
import supportedLanguages from './assets/i18n/supported-languages.json';
import { langCode } from './modules/util';

// Default to English initially
let intlDefinition = English;
export const deviceLanguage = langCode;

// Function to load the language file dynamically
const loadIntlDefinition = async (language: string) => {
  try {
    const module = await import(`./assets/i18n/${language}.json`);
    return module.default;
  } catch (error) {
    console.error(`Error loading language file for ${language}:`, error);
    return English; // Fallback to English if the file is missing
  }
};


const initializeI18n = async () => {
  if (supportedLanguages.includes(deviceLanguage)) {
    intlDefinition = await loadIntlDefinition(deviceLanguage);
  }

  // Set up resources
  const resources = {
    [deviceLanguage]: {
      translation: intlDefinition,
    },
    en: {
      translation: English,
    },
  };
  i18next.use(initReactI18next).init({
    resources,
    lng: deviceLanguage ?? 'en', 
    fallbackLng: 'en', 
    interpolation: {
      escapeValue: false, 
    },
  });
};

initializeI18n();

export default i18next;